export default {
  setProjects: (state, payload) => (state.projects = payload),
  setUsers: (state, payload) => (state.users = payload),
  setLegalEntities: (state, payload) => (state.legalEntities = payload)
}
